import { html, nothing } from "lit";
import { customElement, property, state } from 'lit/decorators.js';
import { connect } from "pwa-helpers";
import { PaymentMethod, PaymentMethodTemplate } from "../payment-method";
import "../../address/address-form";
import { booleanConverter } from "../../../common/converters";
import { getBillingAddress, isShippingAddressFromAddressbook, updateBillingAddress, updatePaymentDetails, updatePoOrderNumber } from "../../checkout/shop-checkout";
import { isSegUser, selectUser } from "../../user-profile/user-profile.selectors";
import { waitForElementsToLoad } from "../../../common/utils/delay-util";
import { PaymentDetails, PaymentType } from "../../checkout/shop-checkout.interface";
import store from "../../../store/store";
import { StoreState } from "../../../store/store.interface";

@customElement(`mhecomm-po-order-payment-method`)
export class PoOrderPaymentMethod extends connect(store)(PaymentMethod) implements PaymentMethodTemplate {

  @state()
  private poNumber: string | undefined;

  @state()
  private poNumberIsValid = true;

  @property({converter: booleanConverter})
  shippable = false;
  
  @property({type: Number})
  totalAmount = 0;

  private poNumberId = `poNumber`;

  constructor() {
    super();
  }

  renderComp() {
    if (!this.isSelected) {
      return nothing;
    }

    return html`
       <form id="${this.id}" class="row g-3">
        <div class="col-md-6">
          <h3 class="fw-semibold fs-4 mt-2">Pay with a purchase order</h3>
          <label for="${this.poNumberId}" class="form-label">Purchase Order Number</label>
          <input type="text" class="form-control" id="${this.poNumberId}" .value="${this.poNumber || ""}" 
            @input=${(_e: InputEvent) => updatePurchaseOrderNumber((_e.target as HTMLInputElement).value)} required>
          <p id="${this.poNumberId}-field-error"  class=${ this.poNumberIsValid ? 'invalid-feedback d-none' : 'invalid-feedback d-block'}>${this.uxtIconReady ? html`<uxt-icon icon="exclamation-triangle"></uxt-icon>` : ''}Please enter a Purchase Order Number to proceed</p>
        </div>
        ${this.renderBillingAddressForm()}
        </form>
    `;
  }

  stateChanged(state: StoreState): void {
    this.updateIsSelected(PaymentType.PURCHASE_ORDER, state);
    this.poNumber = state.shopCheckoutState.poOrderNumber;
    this.billingAddress = getBillingAddress(store.getState() as StoreState) || this.billingAddressInitialState;
  }

  public async validatePaymentMethod(): Promise<void> {
    this.poNumberIsValid = this.poNumber === '' || this.poNumber === undefined ? false : true;

    if(!this.poNumberIsValid) {
      throw new Error("PO order Number is required");
     }
    if(!this.isSameAsShippingAddress ){
      const addressForm = this.getAddressForm();
      await addressForm.validate()
      .then(addressValidationInfo => {
        if(addressValidationInfo){
          store.dispatch(updateBillingAddress(addressValidationInfo));
        }
      })
    }
  }

  paymentMethodSuccessAction(): void {
    throw new Error("Method not implemented.");
  }

  paymentMethodFailureAction(): void {
    throw new Error("Method not implemented.");
  }
  
  connectedCallback() {
    super.connectedCallback();
    this.showUseShippingAddressButton = isSegUser(selectUser(store.getState() as StoreState)) ? !isShippingAddressFromAddressbook(store.getState() as StoreState) : true;
    this.poNumber = store.getState().shopCheckoutState.poOrderNumber;
  }

  paymentMethodEditAction(): void {
    waitForElementsToLoad(this.shadowRoot!, ["mhecomm-address-form"]).then(() => {
      this.getAddressForm().prepopulate(getBillingAddress(store.getState() as StoreState)!);
      store.dispatch(updateBillingAddress(undefined));
    });
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'mhecomm-po-order-payment-method': PoOrderPaymentMethod;
  }
}

function updatePurchaseOrderNumber(poNumber: string) {
  store.dispatch(updatePoOrderNumber(poNumber));
  const paymentDetails: PaymentDetails = {
    paymentType: PaymentType.PURCHASE_ORDER
  };
  store.dispatch(updatePaymentDetails(paymentDetails));
 }
